import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const OtpLoginGuard = () => {
  const router = inject(Router);
  const id = localStorage.getItem('otp-id');
  if (id) {
    router.navigate(['otp/upload']);
    return false;
  }
  return true;
};
